import React, { useEffect, useState } from 'react'
import userbase from 'userbase-js'
import { AccountCreated } from './home/AccountCreated'
import { Profile } from './home/Profile'
import { useLocation } from 'react-router-dom'

export const Home = ({ user }) => {
  const location = useLocation()

  const [people, setPeople] = useState()

  const DATABASE_NAME = 'bubble'

  useEffect(() => {
    if (user) {
      userbase.openDatabase({ databaseName: DATABASE_NAME, changeHandler })
    }
  }, [user])

  const changeHandler = (items) => {
    setPeople(items)
  }

  const removePerson = (id) => {
    userbase.deleteItem({ databaseName: DATABASE_NAME, itemId: id })
  }

  return (
    <>
      <AccountCreated location={location} />
      <Profile
        user={user}
        location={location}
        people={people}
        removePerson={removePerson}
      />
    </>
  )
}
